module.exports = __webpack_public_path__ + "img/schilten.cc7b925e.png";